import LegalPage from "@/components/shared/LegalPage";

export default function TermsAndConditionsPage() {
  return (
    <LegalPage
      pageTestId="wc-terms-and-conditions"
      documentTitle="Terms & Conditions"
      title="Terms & Conditions"
      lastUpdated="July 2026"
      intro={[
        "These Terms & Conditions govern your use of WinCampaign's website, software, products, and services.",
        "By accessing this website or purchasing our services, you agree to these Terms.",
      ]}
      sections={[
        {
          heading: "Services",
          paragraphs: [
            "WinCampaign provides marketing-related products and services which may include:",
          ],
          bullets: [
            "Done-for-You Social Media Marketing",
            "Content Creation",
            "Content Scheduling",
            "Lead Generation Support",
            "Business Growth Accelerator",
            "Marketing Software",
            "Business Education",
            "Business Resources",
            "Coaching Materials",
          ],
        },
        {
          paragraphs: ["Services may evolve over time as we improve our platform."],
        },
        {
          heading: "No Guarantees",
          paragraphs: ["WinCampaign does not guarantee:"],
          bullets: [
            "Sales",
            "Customers",
            "Leads",
            "Subscribers",
            "Revenue",
            "Business Growth",
            "Earnings",
            "Social Media Performance",
          ],
        },
        {
          paragraphs: [
            "Success depends on your implementation, consistency, business model, sales process, and many other factors outside our control.",
          ],
        },
        {
          heading: "Client Responsibilities",
          paragraphs: ["Clients agree to:"],
          bullets: [
            "Complete onboarding promptly",
            "Provide accurate information",
            "Supply requested branding assets",
            "Respond to communication in a timely manner",
            "Maintain access to required accounts",
            "Comply with applicable laws and platform policies",
          ],
        },
        {
          paragraphs: [
            "Failure to provide requested information may delay service delivery.",
          ],
        },
        {
          heading: "Payments",
          paragraphs: [
            "Subscriptions renew automatically according to the selected billing cycle unless canceled before the next renewal date.",
            "Clients authorize recurring billing upon purchase.",
          ],
        },
        {
          heading: "Intellectual Property",
          paragraphs: [
            "Unless otherwise agreed:",
            "WinCampaign retains ownership of:",
          ],
          bullets: [
            "Frameworks",
            "Training",
            "Templates",
            "Systems",
            "Software",
            "Branding",
            "Educational Materials",
            "Proprietary Processes",
          ],
        },
        {
          paragraphs: [
            "Clients receive a limited license to use delivered marketing materials while maintaining an active subscription.",
          ],
        },
        {
          heading: "Acceptable Use",
          paragraphs: ["You agree not to:"],
          bullets: [
            "Copy or redistribute proprietary materials",
            "Reverse engineer our systems",
            "Use our services for unlawful purposes",
            "Misrepresent WinCampaign or its products",
          ],
        },
        {
          heading: "Limitation of Liability",
          paragraphs: [
            "To the fullest extent permitted by law, WinCampaign shall not be liable for indirect, incidental, special, or consequential damages.",
            "Our total liability shall never exceed the amount paid by the client during the previous thirty (30) days.",
          ],
        },
        {
          heading: "Modifications",
          paragraphs: [
            "WinCampaign reserves the right to update these Terms at any time.",
            "Continued use of our services constitutes acceptance of any modifications.",
          ],
        },
        {
          heading: "Governing Law",
          paragraphs: [
            "These Terms shall be governed by the laws of the Province of Manitoba and the applicable laws of Canada.",
          ],
        },
        {
          heading: "Contact",
          paragraphs: ["support@wincampaign.io"],
        },
      ]}
    />
  );
}
